import { render, staticRenderFns } from "./PersonalInfo.vue?vue&type=template&id=f3f164d8&scoped=true"
import script from "./PersonalInfo.vue?vue&type=script&lang=js"
export * from "./PersonalInfo.vue?vue&type=script&lang=js"
import style0 from "./PersonalInfo.vue?vue&type=style&index=0&id=f3f164d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f164d8",
  null
  
)

export default component.exports